'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: {
        animationCollapseDuration: {
            type: Number,
            kComposite: 'animation.collapse.duration'
        },
        animationCollapseEffects: {
            type: String,
            kComposite: 'animation.collapse.effects'
        },
        animationExpandDuration: {
            type: Number,
            kComposite: 'animation.expand.duration'
        },
        animationExpandEffects: {
            type: String,
            kComposite: 'animation.expand.effects'
        }
    }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@progress/kendo-layout-vue-wrapper/dist/es/KendoPanelBar/Animation.js
// module id = 670
// module chunks = 0